module.exports = __webpack_public_path__ + "static/media/faq1x1.48a2f252.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/faq1x1.png
// module id = 1266
// module chunks = 1